// Component: TestingCommissionList.jsx
// Description: This component is utilized for viewing the testing commission list.
import React, { useState, useEffect } from 'react';
import { Box, Stack, Modal } from '@mui/material';
import CustomAgGrid from '../commoncomponents/CustomAgGrid';
import { useDispatch } from "react-redux";
import dayjs from 'dayjs';
import CustomDialog from '../commoncomponents/CustomDialog';
// import { useNavigate } from 'react-router-dom';
import { DefaultCard } from '../../assets/styled-components/card';
import RefreshExportButtons from '../commoncomponents/RefreshExportButtons';
import { DispatchAction, setBasicDetailsFields, setOthersDetailsFields, } from "../../redux/actions/TestingCommission/dispatchActions";
import TCActionsTypes from "../../redux/actions/TestingCommission/TCActionTypes";
import { deleteTC, getTCListByID, getbemExportList, getbemTCList, getfemExportList, getfemTCList } from './testingCommissionAPIs';
import CustomSelectInput from '../commoncomponents/CustomSelectInput';
import PageTitle from '../commoncomponents/PageTitle';
import SectionTitle from '../commoncomponents/SectionTitle';
import CloseButton from '../commoncomponents/CloseButton';
import CreateNewBtn from '../commoncomponents/CreateNewBtn';
import { ErrorChips, SuccessChips, WarningChips } from '../../assets/styled-components/chips';
import Axios from 'axios';
import { getAuthToken } from "../../utility/tokenUtility";
import { FemsGraph, BemsGraph } from "../../utility/apiURLS";
import Tcviewfile from './Tcviewfile';
import { jsPDF } from "jspdf";
import html2canvas from 'html2canvas';
import { createRoot } from 'react-dom/client';
import { mandatoryFields } from '../../redux/actions/assetActions';
import CustomAlert from '../userlocationcomponents/CustomAlert';
import { useLocation, useNavigate } from "react-router-dom";
import { useAccess } from "../../AccessContext";
import utilities from '../../utility/utilities';

const columns = [
  { field: 'testingcommissionno', headerName: 'T&C No', minWidth: 200 },
  { field: 'warrantyexpirydateFormate', headerName: 'T&C End Date' },
  { field: 'typecode', headerName: 'Type Code' },
  { field: 'assetdesc', headerName: 'Asset Description' },
  { field: 'workgroup', headerName: 'Work Group' },
  {
    field: 'status',
    headerName: 'Status',
    cellRenderer: (params) => {
      if (params?.value === "Submitted" || params?.value === "Authorized" || params?.value === "Completed") {
        return <SuccessChips label={params.value} />;
      } else if (params?.value === "In-Progress") {
        return <WarningChips label={params.value} />;
      }
      else if (params?.value === "Rejected" || params?.value === "Open") {
        return <ErrorChips label={params.value} />;
      }
    },
  },
  { field: 'assetno', headerName: 'Converted Asset No' }
];


const TestingCommissionList = () => {
  const location = useLocation();
  const [isView, setIsView] = useState(false);
  const [rows, setRows] = useState([]);
  const [gridApi, setGridApi] = useState({});
  const [deleteTCConfirmation, setDeleteTCConfirmation] = useState(false);
  const [currentRow, setCurrentRow] = useState({});
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const accessData = useAccess();
  const access = utilities.getScreenPermissions(accessData, "TNCG001");
  const roleName = localStorage.getItem('roleName');
  const vendorAccess = roleName === 'Vendors' ? true : false;

  const [service, setService] = useState({ id: 1, label: 'FEMS', value: 'FEMS' });
  const serviceOptions = [
    { id: 1, label: 'FEMS', value: 'FEMS' },
    { id: 2, label: 'BEMS', value: 'BEMS' },
  ];
  const [isLoading, setIsLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [showMessage, setShowMessage] = useState(false);
  const [data, setData] = useState(null);
  const [isError, setIsError] = useState(false);

  //pagination state
  const [filterModel, setFilterModel] = useState([]);
  const [sortModel, setSortModel] = useState([]);
  const [pageIndex, setPageIndex] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [rowCount, setRowCount] = useState(0);
  const [exportData, setExportData] = useState([]);
  const [exportCount, setExportCount] = useState(0);
  const [totalDataCount, setTotalDataCount] = useState({ fem: 0, bem: 0 });
  const getTestingCommissionList = async () => {
    try {
      setIsLoading(true);
      let list;
      // Fetch list based on the type parameter
      if (service?.label === 'FEMS') {
        list = await getfemTCList(pageIndex, pageSize, filterModel, sortModel);
      } else if (service?.label === 'BEMS') {
        list = await getbemTCList(pageIndex, pageSize, filterModel, sortModel);
      }
      // Modify date format
      const modifiedList = list?.items?.map((data) => ({
        ...data,
        testingcommissionstartdate: dayjs(data.testingcommissionstartdate).format('DD/MM/YYYY'),
        testingcommissioncompletedate: dayjs(data.testingcommissioncompletedate).format('DD/MM/YYYY'),
        enableDownload: data?.status === "Authorized" ? true : false,

      }));

      // Set state based on the type
      if (service?.label === 'FEMS') {
        setRows(modifiedList); // Set rows only when fetching FEM list
        setIsLoading(false)
        if (list?.totalCount) {
          setRowCount(list?.totalCount);
          setExportCount(list?.totalCount);
          setTotalDataCount((prev) => ({ ...prev, fem: list?.totalCount }));
        }
      } else if (service?.label === 'BEMS') {
        setTotalDataCount((prev) => ({ ...prev, bem: list?.totalCount }))
        list?.totalCount && setRowCount(list?.totalCount);
        list?.totalCount && setExportCount(list?.totalCount)
        setRows(modifiedList); // Set rows only when fetching BEM list
        setIsLoading(false);
      }
    } catch (error) {
      console.log(`Error fetching ${service?.label} testing commission details:`, error);
    }
  };

  const handleSwitchChange = () => {
    // Access the checked state of the switch using event.target.checked
    // Perform actions based on the switch state (isChecked)
    dispatch(mandatoryFields(false, "UPDATE_MANDATORY_REQUIRED_ENABLED"));
  };

  useEffect(() => {
    dispatch({ type: 'RESET_TC_FIELD_VALUES', payload: {} });
    dispatch({ type: 'RESET_BASIC_DETAILS_FIELDS', payload: {} });
    dispatch({ type: 'RESET_OTHERS_DETAILS_FIELDS', payload: {} });
    handleSwitchChange(); //for issue no:IF-980 i have handled this switch change whithout changing the common component
  }, []);

  useEffect(() => {
    getTestingCommissionList(); //render the default fem records
  }, [filterModel, sortModel, pageIndex, pageSize, service?.label]);

  //Export Data 
  // Export Data
  const getTestingCommissionExportList = async () => {
    try {
      let list;
      // Fetch list based on the type parameter
      if (service?.label === 'FEMS') {
        list = await getfemExportList(filterModel, sortModel);
      } else if (service?.label === 'BEMS') {
        list = await getbemExportList(filterModel, sortModel);
      }

      if (list?.length > 0 && Array.isArray(list)) {
        setExportData(list)
      }

    } catch (error) {
      console.log(`Error fetching ${service?.label} testing commission details:`, error);
    }
  };

  const handleCreate = () => {
    dispatch(DispatchAction(TCActionsTypes.NEXT_PAGE, { currentPage: 'Basic Details' }));
    navigate('register', { state: { mode: 'create' } });
  };

  const handleRefresh = () => {
    setPageIndex(1);
    setPageSize(10);
    setFilterModel([])
    setSortModel([])
  };

  const handleDelete = (row) => {
    setCurrentRow(row);
    setDeleteTCConfirmation(true);
  }

  const confirmDelete = async () => {
    if (!currentRow?.assetno) {
      const id = currentRow?.id;
      const type = currentRow?.serviceDesc === 'FEMS' ? 'FEMS' : 'BEMS';
      const resposeAfterDelete = await deleteTC(id, type);
      if (resposeAfterDelete) {
        setDeleteTCConfirmation(false);
        getTestingCommissionList();
      }
    } else {
      setDeleteTCConfirmation(false);
      setShowMessage(true);
      setErrorMessage("Record cannot be deleted as it is referred in another record.");
    }
  };

  //method to set the BasicDetails fields in edit mode
  const setBasicDetailsInfoInEditMode = async (response, rowData) => {
    const { serviceid, serviceDesc, typecode, typecodeDesc, typecodeid, vendorid, vendorname, vendorcode, workgroupid, workgroup, wgdesc } = rowData;
    const serviceData = { id: serviceid, label: serviceDesc, value: serviceDesc };
    const typecodeData = { id: typecodeid, label: typecode, value: typecodeDesc, typecode: typecode };
    const vendorData = { id: vendorid, label: `${vendorname}`, value: vendorcode, vendorname: vendorname };
    const workgroupData = { id: workgroupid, label: `${workgroup} - ${wgdesc}`, value: workgroup };
    const criticality = [{ key: 'option-0', label: 'Normal', isvisible: true, id: 1 },
    { key: 'option-1', label: 'Critical', isvisible: true, id: 2 }]
    const criticalityObj = criticality?.find((item) => item?.label === response?.riskstatus)
    const basicDetailsTc = {
      criticality: response?.riskstatus ? criticalityObj : '',
      isDateSetInEditMode: false,
      isEditMode: true,
      id: response?.id,
      testingcommissionno: response?.testingcommissionno,
      status: '',
      // basicDetails mandatory fields
      service: serviceid ? serviceData : '',
      vendorname: vendorid ? vendorData : '',
      typecode: typecodeid ? typecodeData : '',
      workgroup: workgroupid ? workgroupData : '',
      assetdesc: response?.assetdesc || '',
      testingcommissionstartdate: dayjs().format('YYYY-MM-DDTHH:mm:ss') || '',
      //non mandatory fields
      location: '',
      model: response?.model || '',
      serialno: response?.serialno || '',
      chassisno: response?.chassisno || '',
      registerno: response?.registerno || '',
      purchaseprice: response?.purchaseprice || '',
      purchaseorderno: response?.purchaseorderno || '',
      financeassetno: response?.financeassetno || '',
      manufacturer: response?.manufacturer || '',
      warrantystartdate: response?.warrantystartdate ? dayjs(response?.warrantystartdate).format('DD/MM/YYYY') : '',
      warrantyexpirydate: response?.warrantyexpirydate ? dayjs(response?.warrantyexpirydate).format('DD/MM/YYYY') : '',
      isunderwarranty: "",
      lifespan: response?.lifespan || '',
      istestpassed: response?.istestpassed !== undefined ?
        (response?.istestpassed === true ? { value: true, label: 'PASSED' } : { value: false, label: 'FAILED' }) :
        '',
      testingcommissioncompletedate: response?.testingcommissioncompletedate ? dayjs(response?.testingcommissioncompletedate).format('DD/MM/YYYY') : '',
      remarks: response?.remarks || '',
    };
    dispatch(setBasicDetailsFields(basicDetailsTc));
    return basicDetailsTc;

  }

  //method to set the otherDetails fields in edit mode
  const setOthersDetailsInfoInEditMode = async (response) => {
    const getClass = response?.class?.split(',');
    const getPowerCard = response?.powercord?.split(',');
    const getReferenceNo = response?.referenceno?.split(',');
    const getProof = response?.isdefibrillationproof;
    const proof = (getProof && getProof === true ? { value: true, label: 'YES' } : { value: false, label: 'NO' }) || '';
    const getType = response?.type?.split(',');
    const values = {
      class: {
        class1: getClass?.includes('class1'),
        class2: getClass?.includes('class2'),
        class3: getClass?.includes('class3'),
        IP: getClass?.includes('IP'),
        NA: getClass?.includes('NA')
      },
      powerCard: {
        nonDetachable: getPowerCard?.includes('nonDetachable'),
        detachable: getPowerCard?.includes('detachable'),
        strainRelief: getPowerCard?.includes('strainRelief'),
        medicalGrade: getPowerCard?.includes('medicalGrade')
      },
      referenceNo: {
        IEC60950: getReferenceNo?.includes('IEC60950'),
        IEC60601: getReferenceNo?.includes('IEC60601'),
        IEC61010: getReferenceNo?.includes('IEC61010')
      },
      type: {
        B: getType?.includes('B'),
        BF: getType?.includes('BF'),
        CF: getType?.includes('CF'),
        NA: getType?.includes('NA')
      },
      proof: proof,
      isDataSetInEditMode: true,
      isEditMode: true
    }
    dispatch(setOthersDetailsFields(values));
    return values;
  };

  const handleEdit = async (rowData) => {

    const response = await getTCListByID(rowData?.id, rowData?.serviceDesc === 'FEMS' ? 'FEMS' : 'BEMS');
    if (response) {
      dispatch({ type: TCActionsTypes?.SET_TC_FIELD_VALUES, payload: { ...response[0], status: rowData?.status, isEditMode: true } });
      //set the values in edit mode
      const basicDetailsFieldValue = await setBasicDetailsInfoInEditMode(response[0], rowData);
      const basicDetailsFieldValueTcOthers = await setOthersDetailsInfoInEditMode(response[0]);
      navigate('register', {
        state: {
          mode: 'edit', basicDetails: { ...basicDetailsFieldValue }, TcOthers: { ...basicDetailsFieldValueTcOthers },
          tcDetails: { ...response[0], status: rowData?.status, isEditMode: true }, rowData: { ...rowData }, service: rowData?.serviceDesc
        }
      });
      dispatch(DispatchAction(TCActionsTypes.NEXT_PAGE, { currentPage: 'Basic Details' }));
    } else {
      setIsError(true);
      console.log('Could not get T&C details');
    }
  };

  const handleView = async (rowData) => {
    // isViewMode
    const response = await getTCListByID(rowData?.id, rowData?.serviceDesc === 'FEMS' ? 'FEMS' : 'BEMS');
    if (response) {
      dispatch({ type: TCActionsTypes?.SET_TC_FIELD_VALUES, payload: { ...response[0], status: rowData?.status, isViewMode: true } });
      //set the values in edit mode
      const basicDetailsFieldValue = await setBasicDetailsInfoInEditMode(response[0], rowData);
      const basicDetailsFieldValueTcOthers = await setOthersDetailsInfoInEditMode(response[0]);
      navigate('register', {
        state: {
          mode: 'view', basicDetails: { ...basicDetailsFieldValue }, TcOthers: { ...basicDetailsFieldValueTcOthers },
          tcDetails: { ...response[0], status: rowData?.status, isEditMode: true }
        }
      });
      dispatch(DispatchAction(TCActionsTypes.NEXT_PAGE, { currentPage: 'Basic Details' }));
    } else {
      setIsError(true);
      console.log('Could not get T&C details');
    }
  }

  const handleDownload = async (id) => {
    const servicetype = service?.label;
    try {
      const token = getAuthToken("id_token");
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };

      let response;
      if (servicetype === "FEMS") {
        response = await Axios.get(`${FemsGraph}/api/TestingandCommission/GetDownloadreporttandclistfem/${id}`, config);
      } else {
        response = await Axios.get(`${BemsGraph}/api/TestingandCommission/GetDownloadreporttandclistbem/${id}`, config);
      }

      if (response && response.data) {
        setData(response.data);

        await downloadPDF(response.data);
      }
    } catch (error) {
      console.log("Error downloading the report:", error);
    }
  };

  const downloadPDF = async (data) => {
    setIsView(false);
    const printRef = document.createElement("div");
    printRef.style.position = "absolute";
    printRef.style.top = "-8888px"; // Move it off-screen
    printRef.style.left = "-8888px"; // Move it off-screen
    printRef.style.zIndex = "888"; // Set desired z-index
    document.body.appendChild(printRef);


    const padding = 1;
    const contentWidth = 210 - 2 * padding;
    const contentHeight = 297 - 2 * padding;

    const tcViewComponent = (
      <Box
        sx={{
          padding: '10px',
          margin: '0',
          width: `${contentWidth}mm`,
          height: `${contentHeight}mm`,
          backgroundColor: '#fff',
        }}
      >
        <Tcviewfile data={data} />
      </Box>
    );

    const root = createRoot(printRef);
    root.render(tcViewComponent);

    try {

      await new Promise((resolve) => setTimeout(resolve, 500));


      const canvas = await html2canvas(printRef, {
        scale: 2,
        useCORS: true,
        scrollX: 0,
        scrollY: 0,
        windowWidth: 210 * 3.7795275591,
        windowHeight: 297 * 3.7795275591,
      });

      const imgData = canvas.toDataURL("image/png");

      const pdf = new jsPDF({
        orientation: 'p',
        unit: 'mm',
        format: 'a4',
      });

      const imgWidth = 210 - 2 * padding;
      const imgHeight = (canvas.height * imgWidth) / canvas.width;


      const initialY = padding;
      let heightLeft = imgHeight;
      let position = initialY;


      pdf.addImage(imgData, 'PNG', padding, position, imgWidth, imgHeight);
      heightLeft -= (pdf.internal.pageSize.height - padding * 2);

      while (heightLeft > 0) {
        position = heightLeft - imgHeight;
        pdf.addPage();
        pdf.addImage(imgData, 'PNG', padding, position, imgWidth, imgHeight);
        heightLeft -= (pdf.internal.pageSize.height - padding * 2);
      }

      pdf.save("Commissioning_Report.pdf");
    } catch (error) {
      console.error("Error generating PDF:", error);
    } finally {

      document.body.removeChild(printRef);
    }
  };
 
  const handleFieldChange = (value) => {
    if (value?.label === 'BEMS') {
      setService((prev) => {
        if (prev?.label === 'FEMS') {
          setPageIndex(1);
          setPageSize(10);
          gridApi?.setFilterModel('');
        }
      });
      setRowCount(totalDataCount?.bem)
    }
    if (value?.label === 'FEMS') {
      setService((prev) => {
        if (prev?.label === 'BEMS') {
          setPageIndex(1);
          setPageSize(10);
          gridApi?.setFilterModel('');
        }
      });
      setRowCount(totalDataCount?.fem)
    }
    setService(value);
  };


  return (
    <>
      <PageTitle title="Testing & Commissioning" />
      <DefaultCard>
        <Stack
          mb={1}
          direction={"row"}
          justifyContent={"space-between"}
          alignItems={"center"}
        >
          <SectionTitle title={"Testing & Commissioning List"} />
          <Stack direction={"row"} alignItems={"center"} gap={1} >
            <CustomSelectInput
              fullWidth={false}
              name="service"
              labelSize={"14px"}
              sx={{ width: 150 }}
              highlight={true}
              value={service}
              onChange={(value) => handleFieldChange(value)}
              label={"Service"}
              options={serviceOptions}
              disabled={false}
              isMandatoryField={false}
            />
            {(access?.canCreate || vendorAccess) && <CreateNewBtn onClick={handleCreate} />}
            <RefreshExportButtons
              exportFunction={getTestingCommissionExportList}
              exportData={exportData}
              refData={gridApi}
              handleRefresh={handleRefresh}
              title="Testing & Commissioning"
            />
          </Stack>
        </Stack>

        <Box>
          <CustomAgGrid
            rows={rows}
            columns={columns}
            handleEdit={(access?.canEdit || vendorAccess) && handleEdit}
            handleView={(access?.canView || vendorAccess) && handleView}
            handleDelete={(access?.canDelete || vendorAccess) ? (rows) => handleDelete(rows) : null}
            ref={gridApi}
            handleDownload={(access?.canPrint || vendorAccess) ? (row) => handleDownload(row?.id) : null}
            setGridApi={setGridApi}
            isLoading={isLoading}
            //for pagination
            pagination={false}
            setFilterModel={setFilterModel}
            setSortModel={setSortModel}
            totalCount={rowCount}
            pageIndex={pageIndex}
            pageSize={pageSize}
            setPageIndex={setPageIndex}
            setPageSize={setPageSize}
          />
          <Modal
            sx={
              !isView && {
                "& .MuiBackdrop-root": {
                  backgroundColor: "transparent",
                },
                top: "-9999px",
                left: "-9999px",
                zIndex: "-1",
              }
            }
          >
            <Tcviewfile
            />
          </Modal>
        </Box >
        <CustomDialog
          open={deleteTCConfirmation}
          onClose={() => setDeleteTCConfirmation(false)}
          onConfirm={confirmDelete}
          content="Are you sure you want to delete?"
          cancelBtn="NO"
          confirmBtn="YES"
        />
        <CustomAlert
          opne={isError}
          onClose={() => setIsError(false)}
          onConfirm={() => setIsError(false)}
          content={"Something Went Wrong. Please try again later."}
          confirmBtn={"OK"}
        />
        <CustomDialog
          open={showMessage}
          onClose={() => setShowMessage(false)}
          onConfirm={() => setShowMessage(false)}
          content={errorMessage}
          cancelBtn="CANCEL"
          confirmBtn="OK"
        />
      </DefaultCard>
      <CloseButton />
    </>
  );
};

export default TestingCommissionList;
